import { mapValues } from 'lodash';
/**
 * Version 222 migration adding default text for discounts
 */
export default function v22(website) {
  return {
    ...website,
    eventVersion: 22,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Payment') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            discountHeader: 'EventWidgets_Payment_DiscountCodesHeader__resx',
            applyDiscountButton: 'EventWidgets_Payment_DiscountCodesApply__resx',
            style: {
              ...layoutItem.config.style,
              discountCodesHeader: {
                ...layoutItem.config.style.discountCodesHeader,
                customSettings: {
                  spacing: {
                    padding: {
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      paddingTop: 0
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
